<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import appMetadataApi from "@/api/appMetadata";
export default {
    // created() {
    //     // 获取省市区存入缓存
    //     this.getCity();
    // },
    // methods: {
    //     getCity() {
    //         appMetadataApi.getAppMetadata("1").then((response) => {
    //             let { status, data } = response.data;
    //             if (status == 200) {
    //                 if (Array.isArray(data)) {
    //                     localStorage.setItem('city', JSON.stringify(data))
    //                 }
    //             }
    //         }).catch((error) => {
    //             console.log(error);
    //         });
    //     },
    // },
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
</style>
